import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsLoggedIn } from '@store/slices/auth.slice'
import Header from '@components/header'
import Footer from '@components/footer'
import LoginPage from '@pages/Login'
import DashboardPage from '@pages/DashboardPage'
import EditorPage from '@pages/EditorPage'
import PlaygroundPage from "@pages/PlaygroundPage";
import HelpPage from '@pages/HelpPage'
import NotFoundPage from '@pages/NotFoundPage'
import { useTheme } from '@config/themeContext'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

const App: React.FC = () => {
  const isLoggedIn: boolean = useSelector(selectIsLoggedIn)
  const { theme } = useTheme()
  const PrivateWrapper = () => {
    return isLoggedIn ? <Outlet /> : <Navigate to="/login" />
  }

  return (
    <div
      className={`d-flex flex-column min-vh-100 bg-dark-subtle`}
      data-bs-theme={theme}
    >
      <BrowserRouter>
        {isLoggedIn && <Header />}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={theme}
        ></ToastContainer>
        <div className="flex-grow-1">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<PrivateWrapper />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/editor/:jobId?" element={<EditorPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/playground" element={<PlaygroundPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </div>
        {isLoggedIn && <Footer />}
      </BrowserRouter>
    </div>
  )
}

export default App
